const ACTION_TYPES = {
  ON_TAB_CHANGE: 'ON_TAB_CHANGE',
  REDIRECT_TO_EDIT_TEST_PLAN: 'REDIRECT_TO_EDIT_TEST_PLAN',
  REDIRECT_TO_ADD_TEST_PLAN: 'REDIRECT_TO_VIEW_TEST_PLAN',
  CLOSE_ADD_TEST_PLAN_MODAL: 'CLOSE_ADD_TEST_PLAN_MODAL',
};

export default ACTION_TYPES;
